<template>
  <form class="page-form form-horizontal" @submit.prevent="submit()">
    
    <div class="form-group" v-if="edit">
      <div class="col-sm-offset-2 col-sm-10 text-right" v-if="admin == true">
        <a class="btn btn-primary" type="boton" :href="'backend/fichas/'+data.id+'/editar_orden_pages'">Ordenar rotulos</a>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['title'] }">
      <label for="title" class="col-sm-2 control-label">
        Título
        <a v-if="comments.title" v-tooltip :title="comments.title" href="#" @click.prevent>
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="title" @blur="refreshAlias" v-model="data.title"  @input="showComments.title = true"  />
        <div class="help-block" v-for="e in errors['title']">{{ e }}</div>
        <field-comments v-if="showComments.title" v-model="data.comments.title"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['alias'] }">
      <label for="alias" class="col-sm-2 control-label">Alias</label>
      <div class="col-sm-10">
        <input type="text" class="form-control" id="alias" v-model="data.alias" />
        <div class="help-block" v-for="e in errors['alias']">{{ e }}</div>
      </div>
    </div>
    <!-- se deja visible solo para los admins -->
    <div class="form-group" :class="{ 'has-error': errors['published_at'] }">
      <label for="published_at" class="col-sm-2 control-label">Fecha de actualización</label>
      <div class="col-sm-10">
        <el-date-picker id="published_at" v-model="data.published_at" type="date"  format="dd-MM-yyyy" 
          :picker-options="{ firstDayOfWeek: 1 }" placeholder="Seleccione una fecha">
        </el-date-picker>
        <div class="help-block">Fecha que aparecerá en la ficha del portal</div>
        <div class="help-block" v-for="e in errors['published_at']">El campo fecha de actualización es obligatorio.</div>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['institution_id'] }">
      <label for="institution_id" class="col-sm-2 control-label">Institución</label>
      <div class="col-sm-10">
        <institution-select id="institution_id" v-model="data.institution_id"  :institutions="this.institutions" :disabled="this.backusr.role != 'admin'"></institution-select>
        <div class="help-block" v-for="e in errors['institution_id']"  >El campo institución es obligatorio.</div>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['type'] }">
      <label for="type" class="col-sm-2 control-label">Tipo Documento</label>
      <div class="col-sm-10">
        <page-type-select v-model="data.type" :disabled="this.backusr.role != 'admin'"></page-type-select>
        <div class="help-block" v-for="e in errors['type']">{{ e }}</div>
      </div>
    </div>

    <!-- se deja visible solo para tipo FT -->
    <div v-if="admin == true">
      <div v-if="subcategories && subcategories.length > 0" class="form-group" :class="{ 'has-error': errors['subcategories'] }"  >
        <label for="alias" class="col-sm-2 control-label">Sub Categoría</label>
        <div class="col-sm-10">
          <pages-subcategory-select v-model="data.subcategories" :subcategories="subcategories"></pages-subcategory-select>
          <div class="help-block" v-for="e in errors['subcategories']" >El campo subcategoría es obligatorio, debes seleccionar al menos 1</div>
        </div>
      </div>

      <div class="form-group" :class="{ 'has-error': errors['tags'] }">
        <label for="alias" class="col-sm-2 control-label">Clasificación</label>
        <div class="col-sm-10">
          <pages-tag-select v-model="data.tags" :tags="tags"></pages-tag-select>
          <div class="help-block" v-for="e in errors['tags']" >El campo clasificación es obligatorio, debes seleccionar al menos 1.</div>
        </div>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['image'] }">
      <label for="image" class="col-sm-2 control-label">Imagen</label>
      <div class="col-sm-10">
        <el-upload action="backend/api/files" 
          :headers="{
            'X-CSRF-TOKEN': token,
            'X-Requested-With': 'XMLHttpRequest'
          }"
          :on-change="imageUploadChanged"
          :show-file-list="false" >
          <el-button size="small" type="primary">Click para subir imagen</el-button>
        </el-upload>
        <br />
        <input id="image" type="text" class="form-control" v-model="data.image" placeholder="Ej: http://www.ejemplo.com/imagen.jpg" />
        <div class="help-block">URL de la imagen</div>
        <div class="help-block" v-for="e in errors['image']">{{ e }}</div>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['objective'] }">
      <label for="objective" class="col-sm-2 control-label">
        Descripción
        <a v-if="comments.objective" v-tooltip :title="comments.objective" href="#" @click.prevent >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <editor id="objective" v-model="data.objective" @input="showComments.objective = true"></editor>
        <div class="help-block" v-for="e in errors['objective']">{{ e }}</div>
        <field-comments v-if="showComments.objective" v-model="data.comments.objective"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['beneficiaries'] }">
      <label for="beneficiaries" class="col-sm-2 control-label">
        ¿A quién está dirigido?
        <a v-if="comments.beneficiaries" v-tooltip:title="comments.beneficiaries"  href="#" @click.prevent   >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_beneficiaries" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="beneficiaries" v-model="data.beneficiaries" @input="showComments.beneficiaries = true"  ></editor>
        <div class="help-block" v-for="e in errors['beneficiaries']">{{ e }}</div>
        <field-comments v-if="showComments.beneficiaries" v-model="data.comments.beneficiaries"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['details'] }">
      <label for="details" class="col-sm-2 control-label">
        Detalles
        <a v-if="comments.details" v-tooltip:title="comments.details" href="#" @click.prevent >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_details" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="details" v-model="data.details" @input="showComments.details = true"></editor>
        <div class="help-block" v-for="e in errors['details']">{{ e }}</div>
        <field-comments v-if="showComments.details" v-model="data.comments.details"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['requirements'] }">
      <label for="requirements" class="col-sm-2 control-label">
        ¿Qué necesito para hacer el trámite?
        <a  v-if="comments.requirements" v-tooltip:title="comments.requirements" href="#" @click.prevent >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_requirements" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="requirements" v-model="data.requirements" @input="showComments.requirements = true"  ></editor>
        <div class="help-block" v-for="e in errors['requirements']">{{ e }}</div>
        <field-comments v-if="showComments.requirements" v-model="data.comments.requirements"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['validity'] }">
      <label for="validity" class="col-sm-2 control-label">
        ¿Qué vigencia tiene?
        <a v-if="comments.validity" v-tooltip:title="comments.validity" href="#" @click.prevent >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_validity" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="validity" v-model="data.validity" @input="showComments.validity = true"></editor>
        <div class="help-block" v-for="e in errors['validity']">{{ e }}</div>
        <field-comments v-if="showComments.validity" v-model="data.comments.validity"></field-comments>
      </div>
    </div>

    <div class="form-group">
      <label class="col-sm-2 control-label">¿Cómo y dónde hago el trámite?</label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_howto" on-text="SI" off-text="NO" ></el-switch>
      </div>

      <div class="col-sm-10">
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="active">
            <a href="javascript:void(0);#online" aria-controls="online" role="tab"  data-toggle="tab" >
              <input @click.stop type="checkbox" v-model="data.online" />
              Online
              <span v-if="comments.online_guide" v-tooltip:title="comments.online_guide" href="#"  @click.prevent  >
                <i class="material-icons">comment</i>
              </span>
            </a>
          </li>
          <li role="presentation">
            <a href="javascript:void(0);#office" aria-controls="office" role="tab" data-toggle="tab"  >
              <input @click.stop type="checkbox" v-model="data.office" />
              Oficina
              <span v-if="comments.office_guide" v-tooltip:title="comments.office_guide" href="#" @click.prevent>
                <i class="material-icons">comment</i>
              </span>
            </a>
          </li>
          <li role="presentation">
            <a href="javascript:void(0);#phone" aria-controls="phone" role="tab" data-toggle="tab">
              <input @click.stop type="checkbox" v-model="data.phone" />
              Telefónico
              <span v-if="comments.phone_guide" v-tooltip:title="comments.phone_guide" href="#" @click.prevent >
                <i class="material-icons">comment</i>
              </span>
            </a>
          </li>
          <li role="presentation">
            <a href="javascript:void(0);#mail" aria-controls="mail" role="tab" data-toggle="tab">
              <input @click.stop type="checkbox" v-model="data.mail" />
              Correo
              <span v-if="comments.mail_guide" v-tooltip:title="comments.mail_guide"  href="#"  @click.prevent  >
                <i class="material-icons">comment</i>
              </span>
            </a>
          </li>
          <li role="presentation">
            <a href="javascript:void(0);#consulate"  aria-controls="consulate"  role="tab"  data-toggle="tab"    >
              <input @click.stop type="checkbox" v-model="data.consulate" />
              Consulado
              <span v-if="comments.consulate_guide" v-tooltip:title="comments.consulate_guide"  href="#"  @click.prevent >
                <i class="material-icons">comment</i>
              </span>
            </a>
          </li>
        </ul>
        <div class="tab-content">
          <div role="tabpanel" class="tab-pane active" id="online">
            <editor v-model="data.online_guide" @input="showComments.online_guide = true"></editor>
            <div class="help-block" v-for="e in errors['online_guide']">{{ e }}</div>
            <field-comments v-if="showComments.online_guide" v-model="data.comments.online_guide"></field-comments>
            <!-- <div v-if="admin && data.id_certificate == 0">
              <br />
              <label>¿Trámite disponible dentro de ChileAtiende.gob.cl?</label>&nbsp;&nbsp;
              <el-popover placement="bottom" title="Trámites dentro del sitio" width="200" trigger="click" content="Ingrese la URL interna. Ej: /tramites/t5212, o URL con dominio chileatiende" >
                <el-button slot="reference">?</el-button>
              </el-popover>
              <br />
              <el-radio class="radio" v-model="data.in_site" label="0">No</el-radio>
              <el-radio class="radio" v-model="data.in_site" label="1">Si</el-radio>
              <br />
              <br />
              <template v-if="data.online && data.in_site == 1">
                <label >¿Requiere autenticación mediante ClaveÚnica?</label> <br />
                <el-switch
                    v-model="data.claveunica"
                      on-text="SI"
                      off-text="NO"                    
                  >
                  </el-switch>
                <br />
              </template>

            </div> -->
            <!-- <br /> -->
            <!-- <label>URL trámite en línea</label> -->
            <!-- <input type="text" class="form-control"  id="online_url" v-model="data.online_url" :disabled="!admin && data.in_site == '1'" />
            <div class="help-block error" v-for="e in errors['online_url']">{{ e }}</div>
            <div v-if="admin">
              <br />
              <label>¿Trámite en línea activo permanentemente?</label>
              <br />
              <el-radio class="radio" v-model="data.button_action_active" label="0">No</el-radio>
              <el-radio class="radio" v-model="data.button_action_active" label="1" @input="clearDates">Si</el-radio>
              <br />
              <div v-if="data.button_action_active === '0'">
                <br />
                <label>Defina cuándo está disponible el trámite</label>
                <br />
                <br />
                <div class="rangoFechas">
                  <label>Desde</label>
                  <el-date-picker id="button_action_start" v-model="data.button_action_start" type="date" format="dd-MM-yyyy"  placeholder="Seleccione una Fecha"
                    :disabled="!admin && data.button_action_active === '0'"
                    :picker-options="disablePrevDates"
                    @input="clearEndDate">
                  </el-date-picker>
                  
                  <label>Hasta</label>
                  <el-date-picker v-model="data.button_action_end" type="date" format="dd-MM-yyyy"  popper-class="datepick1"  placeholder="Seleccione una Fecha"
                    :disabled="!admin && data.button_action_active === '0'"
                    :picker-options="disablePrevDates" >
                  </el-date-picker>
                </div>
                <div class="help-block error" v-for="e in errors['button_action_start']">{{ e }}<br/></div>
                <div class="help-block error" v-for="e in errors['button_action_end']">{{ e }}</div>
              </div>
              <br />
              <label>Texto botón de acción</label>
              <br />
              <input
                type="text"
                class="form-control"
                v-model="data.button_action_text"
                id="button_action_text"
                :disabled="!admin"
              />
              <br />
              <div class="help-block error" v-for="e in errors['button_action_text']">{{ e }}</div>
            </div> -->

            <!-- <br /> -->
          </div>
          <div role="tabpanel" class="tab-pane" id="office">
            <editor v-model="data.office_guide" @input="showComments.office_guide = true"></editor>
            <div class="help-block" v-for="e in errors['office_guide']">{{ e }}</div>
            <field-comments v-if="showComments.office_guide" v-model="data.comments.office_guide"></field-comments>
          </div>
          <div role="tabpanel" class="tab-pane" id="phone">
            <editor v-model="data.phone_guide" @input="showComments.phone_guide = true"></editor>
            <div class="help-block" v-for="e in errors['phone_guide']">{{ e }}</div>
            <field-comments v-if="showComments.phone_guide" v-model="data.comments.phone_guide"></field-comments>
          </div>
          <div role="tabpanel" class="tab-pane" id="mail">
            <editor v-model="data.mail_guide" @input="showComments.mail_guide = true"></editor>
            <div class="help-block" v-for="e in errors['mail_guide']">{{ e }}</div>
            <field-comments v-if="showComments.mail_guide" v-model="data.comments.mail_guide"></field-comments>
          </div>
          <div role="tabpanel" class="tab-pane" id="consulate">
            <editor v-model="data.consulate_guide" @input="showComments.consulate_guide = true"></editor>
            <div class="help-block" v-for="e in errors['consulate_guide']">{{ e }}</div>
            <field-comments
              v-if="showComments.consulate_guide"
              v-model="data.comments.consulate_guide"
            ></field-comments>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['cost'] }">
      <label for="cost" class="col-sm-2 control-label">
        ¿Cuál es el costo del trámite?
        <a v-if="comments.cost" v-tooltip:title="comments.cost" href="#"  @click.prevent   >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_cost" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="cost" v-model="data.cost" @input="showComments.cost = true"></editor>
        <div class="help-block" v-for="e in errors['cost']">{{ e }}</div>
        <field-comments v-if="showComments.cost" v-model="data.comments.cost"></field-comments>
      </div>
    </div>

    <div class="form-group" :class="{ 'has-error': errors['legal'] }">
      <label for="legal" class="col-sm-2 control-label">
        Marco Legal
        <a v-if="comments.legal" v-tooltip:title="comments.legal" href="#"   @click.prevent  >
          <i class="material-icons">comment</i>
        </a>
      </label>
      <div class="col-sm-10">
        <el-switch v-model="active.status_legal" on-text="SI" off-text="NO" ></el-switch>
      </div>
      <div class="col-sm-10">
        <editor id="legal" v-model="data.legal" @input="showComments.legal = true"></editor>
        <div class="help-block" v-for="e in errors['legal']">{{ e }}</div>
        <field-comments v-if="showComments.legal" v-model="data.comments.legal"></field-comments>
      </div>
    </div>

    <!-- <div class="form-group" :class="{ 'has-error': errors['keywords'] }">
      <label for="keywords" class="col-sm-2 control-label">Keywords</label>
      <div class="col-sm-10">
        <div class="chip-container" @click="setFocus">
          <div class="chip" v-for="(chip, i) of chips" :key="chip.label">
            {{ chip }}
            <i class="material-icons" @click="deleteChip(i)">clear</i>
          </div>
          <input ref="keywrd"  v-model="currentInput"  @keyup="evalKey"  @keydown.delete="backspaceDelete"  />
        </div>
        <div class="help-block">Ingrese keywords separados por comas (,) .</div>
        <div class="help-block" v-for="e in errors['keywords']">{{ e }}</div>
      </div>
    </div> -->

<!-- Nuevos Rotulos -->
  <div v-for="(item, index) in dataNewR" :key="item.id">
    <div class="form-group new-r" :class="{ 'has-error': errors['title_new_r_'+index] }">
      <div class="row">
        <label for="title_new_r" class="col-sm-2 control-label">Titulo</label>
        <div class="col-sm-6">
          <input type="text" :maxlength="190" class="form-control" id="title_new_r[]" v-model="item.title"/>
          <div class="help-block" v-for="e in errors['title_new_r_'+index]">{{e}}</div>
        </div>
        <div class="col-sm-2">
          <el-switch v-model="item.status" on-text="SI" off-text="NO" ></el-switch>
        </div>
        <div class="col-sm-2">
          <button v-if="admin == true" type="button" class="btn btn-danger" v-on:click="removeR(index)">Eliminar Rotulo</button>
        </div>
      </div>
      <div class="row new-r" :class="{ 'has-error': errors['description_'+index] }">
        <label for="description_" class="col-sm-2 control-label">Descripción</label>
        <div class="col-sm-10">
            <editor v-bind:id="'description_'+random()" v-model="item.description" ></editor>
            <div class="help-block" v-for="e in errors['description_'+index]">{{e}}</div>
        </div>
      </div>
      <input type="hidden" v-model="item.orden"/>
    </div>
  </div>

  <div class="form-group btn-space">
    <div class="col-sm-12 text-right" v-if="admin == true">
      <button  class="btn btn-success" type="button" v-on:click="addR()">Agregar Rotulo</button>
    </div>
  </div>

  <!-- End Nuevos Rotulos -->
  
    <div class="form-group" :class="{ 'has-error': errors['related_pages'] }">
      <label for="related_pages" class="col-sm-2 control-label">Fichas Relacionadas</label>
      <div class="col-sm-10">
        <pages-select id="related_pages" :multipleLimit="0" v-model="data.related_pages"></pages-select>
        <div class="help-block" v-for="e in errors['related_pages']">{{ e }}</div>
      </div>
    </div>
    
    <div class="form-group" v-if="admin">
      <label for="" class="col-sm-2 control-label">¿Habilitar elegibilidad?</label>
      <div class="col-sm-10">
        <el-switch v-model="data.eligibility" on-text="SI" off-text="NO" >
            </el-switch>
      </div>
    </div>
    <!-- <div v-show="admin" class="form-group">
      <label for=""  class="col-sm-2 control-label">Revisión orden componentes</label>
      <div class="col-sm-10">
          <a :href="'backend/fichas/'+ data.id +'/editar-orden-componentes'" class="btn btn-primary" >Click Preview y Orden de componentes</a>
      </div>
    </div> -->

    <input type="hidden" id='texto_selector_multiboton' v-model="data.texto_selector_multiboton">

    <div class="form-group">
      <div class="col-sm-offset-2 col-sm-10">
        <a class="btn btn-default" href="backend/fichas">Cancelar</a>
        <button type="submit" class="btn btn-primary">Guardar</button>
      </div>
    </div>
  </form>
</template>
<style lang="scss">
.page-form {
  .el-select {
    display: block;
  }
  .el-select>.el-input {
    display: block;
    min-height: 37px !important;
  }
  .el-upload {
    .el-upload__input {
      display: none;
    }
  }
  .field-comments {
    margin-top: 10px;
  }
}
.error {
  color: red;
}
.chip-container {
  border: 1px solid #ccc;
  border-radius: 4px;
  min-height: 70px;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  .chip {
    margin: 4px;
    background: #e0e0e0;
    padding: 0px 4px;
    border: 1px solid #ccc;
    border-radius: 3px;
    display: flex;
    align-items: center;
    i {
      cursor: pointer;
      opacity: 0.56;
      margin-left: 8px;
    }
  }
  input {
    flex: 1 1 auto;
    width: 30px;
    border: none;
    outline: none;
    padding: 6px 12px;
  }
}
.el-popover {
  color: black;
}

.rangoFechas {
  display: -webkit-box !important;
  display: flex !important;
  flex-flow: wrap;
  -webkit-box-pack: space-between;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.new-r{
  padding-top: 15px;
  padding-bottom: 5px;
}

.btn-space{
  padding-top: 1%;
}
</style>
<script>
import ElDatePicker from "element-ui/lib/date-picker";
import ElUpload from "element-ui/lib/upload";
import ElButton from "element-ui/lib/button";
import Tooltip from "../directives/Tooltip";
import Editor from "./Editor.vue";
import PagesSelect from "./PagesSelect.vue";
import FieldComments from "./FieldComments.vue";
import ElRadio from "element-ui/lib/radio";
import ElPopover from "element-ui/lib/popover";
import InstitutionSelect from "./InstitutionSelect.vue";
import PagesSubcategorySelect from "./PagesSubcategorySelect.vue";
import PagesTagSelect from "./PagesTagSelect.vue";
import PageTypeSelect from "./PageTypeSelect";
import ElementUI from "element-ui";
import ElSwitch from "element-ui/lib/switch";
import { Message } from "element-ui";

export default {
  data: function() {
    const page = _.cloneDeep(this.page);
    const active = _.cloneDeep(this.status);
    const comments = _.cloneDeep(this.page.comments);
    const certs = _.cloneDeep(this.certificados);
    const today = moment().startOf("day");
    this.page.comments = {};
    let pre_dataNewR = [];
    let page_new_rotulos = page.metadata_newpages ? JSON.parse(page.metadata_newpages).new_elements : null;
if (page.metadata_newpages) {
  page_new_rotulos.forEach((element, index) => {
    let variable = Object.keys(element);
    variable.forEach(element2 => {
      let item = element[element2][0];
      item.id = Date.now() + Math.random();
      pre_dataNewR.push(item);
    });
  });
}

    return {
      data: page,
      dataNewR :pre_dataNewR,
      active: active,
      certs: certs,
      showComments: {},
      comments: comments || {},
      token: window.token.content,
      errors: {},
      chips: [],
      currentInput: "",
      dataSubmit: [],
      set: {
        type: Boolean,
        default: true
      },
      disablePrevDates: {
        disabledDate(date) {
          return date < today;
        }
      }
    };
  },
  props: [
    "certificados",
    "page",
    "status",
    "edit",
    "admin",
    "subcategories",
    "institutions",
    "tags",
    "authUserRole",
    "backusr"
  ],
  components: {
    ElDatePicker,
    ElUpload,
    ElButton,
    Editor,
    PagesSelect,
    FieldComments,
    InstitutionSelect,
    PagesSubcategorySelect,
    PagesTagSelect,
    PageTypeSelect
  },
  directives: {
    Tooltip
  },
  created() {
    var keywords = this.page.keywords.split(",");
    var filtered = keywords.filter(function(e) {
      return e;
    });
    filtered = filtered.map(function(s) {
      return String.prototype.trim.apply(s);
    });
    this.chips = filtered;
    this.data.keywords = this.chips.join(", ");
    this.data.in_site = this.data.in_site == false ? "0" : "1";
    this.data.button_action_active = this.data.button_action_active == false ? "0" : "1";
    if (this.backusr.role != 'admin'){
      this.data.institution_id = this.backusr.institution_id;
      this.data.type = (this.data.type == null) ? "FT" : this.data.type;
    }
  },
  methods: {
    submit: function() {
      var self = this;
      var keywordInput = self.currentInput.trim();
      var errors = {};
      var errores = {};
      var valido = true;

      // self.data.in_site = (this.data.in_site == '0') ? false : true;
      self.data.id_certificate         = this.data.id_certificate         == "0"  ? 0    : self.data.id_certificate;
      self.data.certificate_claveunica = this.data.certificate_claveunica == "0"  ? 0    : self.data.certificate_claveunica;
      self.data.status_details         = this.active.status_details       == true ? 1 : 0;
      self.data.status_beneficiaries   = this.active.status_beneficiaries == true ? 1 : 0;
      self.data.status_requirements    = this.active.status_requirements  == true ? 1 : 0;
      self.data.status_cost            = this.active.status_cost          == true ? 1 : 0;
      self.data.status_validity        = this.active.status_validity      == true ? 1 : 0;
      self.data.status_howto           = this.active.status_howto         == true ? 1 : 0;
      self.data.status_legal           = this.active.status_legal         == true ? 1 : 0;

      if (keywordInput.length > 0) {
        this.saveChip();
      }

      // if (self.data.in_site == true && self.data.id_certificate==0) {
      //   if ( self.data.online_url.substring(0, 4) == "http" || self.data.online_url.substring(0, 3) == "www" )
      //   {
      //     if (self.data.online_url.indexOf("chileatiende.cl") > 0 || self.data.online_url.indexOf("chileatiende.gob.cl") > 0 || self.data.online_url.indexOf("localhost:3000") > 0){
      //       valido = true;
      //     }else{
      //       errores["online_url"] = ["URL no puede empezar con 'http', 'www' o no poseer dominio chileatiende cuando es trámite dentro de chileatiende."];
      //       this.data.in_site = this.data.in_site == false ? "0" : "1";
      //       valido = false;
      //     }
      //   }
      // }

      // if (self.data.button_action_text.length == 0) {
      //   errores["button_action_text"] = ["Debe ingresar un texto para el botón de acción." ];
      //   this.data.button_action_active = this.data.button_action_active == false ? "0" : "1";
      //   valido = false;
      // }else
      //   if(self.data.button_action_text.length > 22) {
      //   errores["button_action_text"] = ["Debe ingresar un texto más corto para el botón de acción." ];
      //   this.data.button_action_active = this.data.button_action_active == false ? "0" : "1";
      //   valido = false;
      // }

      // if(self.data.button_action_active ==  "0"){
      //   if(!self.data.button_action_start){
      //     errores["button_action_start"] = ["Debe ingresar desde cuando se encontrara disponible el botón de acción." ];
      //     valido = false;
      //   }
      //   if(!self.data.button_action_end){
      //     errores["button_action_end"] = ["Debe ingresar hasta cuando se encontrara disponible el botón de acción." ];
      //     valido = false;
      //   }        
      // }

      if (!valido) {
          self.errors = errores;
          self.$message.error("Revise los errores en el formulario para continuar.");
          
          return false;
      }
      if(this.dataNewR.length > 0){
        /* validation new R */
        let arrayTmpToValidate = this.dataNewR;
        arrayTmpToValidate.map((element, index) => {
                if (!element.title) {
                    errores['title_new_r_'+index] = ["Debe ingresar un titulo en el nuevo rotulo "+(index + 8)+"."];
                    valido = false;
                }
                if (/^\s+$/.test(element.title)){
                  errores['title_new_r_'+index] = ["El Titulo del rotulo "+(index + 8)+" no pueden ser solo espacios en blanco"];
                  valido = false;
                }
                if (!element.description) {
                    errores['description_'+index] = ["Debe ingresar una descripcion en el nuevo rotulo "+(index + 8)+"."];
                    valido = false;
                }
                let tmpdes = element.description;
                tmpdes = tmpdes.replace('<p>' , '');
                tmpdes = tmpdes.replace('</p>' , '');

                if (/^\s+$/.test(tmpdes)){
                  errores['description_'+index] = ["la Descripción del rotulo "+(index + 8)+" no pueden ser solo espacios en blanco"];
                }
        });  
        if (!valido) {
          self.errors = errores;
          self.$message.error("Revise los errores en el formulario para continuar.");
          return false;
        }
        /* fin validation new R*/
        this.structDataNewR();
        self.data.new_elements = this.dataSubmit;
      }else{
        self.data.new_elements =[];
      }
      // console.log('normal:', this.dataNewR);
      // console.log('nuevo:',this.dataSubmit);
      // console.log('datos a enviar data completa propiedad se llama new_elements',self.data);
      // console.log('datos completos a enviar de nuevo elemento validados',self.data.new_elements);
      axios({
        url: self.edit ? "backend/fichas/" + self.data.id : "backend/fichas",
        method: self.edit ? "PUT" : "POST",
        data: self.data
      })
        .then(function(response) {
          // console.log(response);
          window.location.replace(response.data.redirect);
        })
        .catch(function(error) {
          self.errors = error.response.data.errors;
          self.$message.error(
            "Revise los errores en el formulario para continuar."
          );
          // self.data.in_site = self.data.in_site == false ? "0" : "1";
          // self.data.button_action_active = self.data.button_action_active == false ? "0" : "1";
        });
      
    },
    refreshAlias: function() {
      if (!this.data.alias) this.data.alias = _.kebabCase(this.data.title);
    },
    imageUploadChanged: function(file) {
      if (file.status == "success") {
        this.data.image = file.response;
      } else if (file.status == "fail") {
        alert("No se pudo subir archivo");
      }
    },
    saveChip() {
      const { chips, currentInput, set } = this;
      ((set && chips.indexOf(currentInput) === -1) || !set) &&
        chips.push(currentInput);
      this.currentInput = "";
      this.updateData();
    },
    deleteChip(index) {
      this.chips.splice(index, 1);
      this.updateData();
    },
    backspaceDelete({ which }) {
      which == 8 &&
        this.currentInput === "" &&
        this.chips.splice(this.chips.length - 1);
      this.updateData();
    },
    addR(){
      let newArrayTmp = this.dataNewR;
      let cantNewA = newArrayTmp.length;
      if(cantNewA<6){
          let orden = ((newArrayTmp.length)+1);
          let objtToPush = {
              id: Date.now(),
              title: '',
              description: '',
              status:false,
              orden:(orden + 7)
        }
        newArrayTmp.push(objtToPush);
        this.dataNewR = newArrayTmp;
      }else{
          this.$message.error("Error no puede agregar mas rotulos");
      }
   
    },
    removeR(position){
      this.dataNewR.splice(position, 1);
    },
    random() {
          return (new Date()).getTime() + Math.floor(Math.random() * 10000).toString()
    },
    structDataNewR(){
      let oldArrayTmp = this.dataNewR;
      let newArrayTmp = [];
      let propertyReserverWord = 'element_';
      oldArrayTmp.map((element, index) => {
        let newObjec = new Object();
        newObjec[propertyReserverWord+(index+1)]= element;
        newArrayTmp.push(newObjec);
      });
      this.dataSubmit = newArrayTmp;
    },
    evalKey: function(event) {
      if (event.key === ",") {
        this.currentInput = this.currentInput.split(",").join("");
        if (this.currentInput.length) {
          this.saveChip();
        }
      }
    },
    updateData() {
      this.data.keywords = this.chips.join(", ");
    },
    setFocus() {
      this.$refs.keywrd.focus();
    },
    clearEndDate:function(){
      this.data.button_action_end='';
    },
    clearDates: function(){
      this.data.button_action_start ='';
      this.data.button_action_end ='';
    }
  }
};
</script>
